import * as go from 'gojs';

import { ForceLayoutSettings } from 'src/containers/ProjectDiagram/templates/extensions/layouts/types';

export const getTextLength = (
  layoutSettings: ForceLayoutSettings,
  linkLabel: go.TextBlock | null
) => (linkLabel?.measuredBounds.width ?? 0) + layoutSettings.labelTextPadding;
